import React, { useState } from 'react'

import MainHeaderNew from './components/MainHeaderNew.js'
import {
  CaseStudyBlock,
  TestimonialBlock,
  Footer,
  GetInTouchBlock,
  SecondaryPageTopBlock
} from './components/helpers.js'
import useAnimationEffects from './components/useAnimationEffects.js'

function IndustryPage(props) {

  //animation for bg lines and lines in getintouch block
  useAnimationEffects('secondary_page');

	return (
		<div className="main-page-layout companies-page" id='scrollableElement'>
			<MainHeaderNew />
      <div className='main-content-new'>

        <SecondaryPageTopBlock index={2} />

        <CaseStudyBlock index={2}/>

        <TestimonialBlock index={3} />

        <GetInTouchBlock index={6} />

        <Footer />

      </div>
		</div>
	)
}

export default IndustryPage;
